import Vue from "vue";

export const notificationService = {
  create
};

function create(payload) {
  return Vue.axios.post("v2/manager/notifications", payload);
}
